module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pad-10"
  }, [(_vm.initialised) ? _c('div', {
    staticClass: "panel panel-default panel-table"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-6 col-md-8"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.tableTitle))])]), _vm._v(" "), (_vm.showCount) ? _c('div', {
    staticClass: "col col-xs-6 col-md-4 text-right"
  }, [_c('div', {
    staticClass: "form-inline",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('label', {
    staticClass: "form-label hidden-xs",
    attrs: {
      "for": 'vuetable-' + _vm._uid
    }
  }, [_vm._v("\n              Per page\n            ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultsPerPage),
      expression: "resultsPerPage"
    }],
    staticClass: "form-control",
    attrs: {
      "id": 'vuetable-' + _vm._uid
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.resultsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.resetPage]
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "500"
    }
  }, [_vm._v("500")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary sq",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        _vm.showSettings = !_vm.showSettings
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6",
    staticStyle: {
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "data-toggle": "tooltip",
      "title": "This will filter against all values within the item, not just those on display! This is limited to 500 records maximum"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.tableData.length > 500,
      "type": "text",
      "placeholder": "Filter results"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    on: {
      "click": function($event) {
        _vm.searchText = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6",
    staticStyle: {
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [(_vm.showSelectAll) ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.promptSelectAll === false) ? _c('div', {
    class: _vm.selectAllBtnClasses,
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.promptSelectAll = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectAllAction || 'Delete') + " " + _vm._s(_vm.tableData.filter(function (ref) {
    var selected = ref.selected;

    return selected;
  }).length) + " selected item(s)\n            ")]) : _vm._e(), _vm._v(" "), (_vm.promptSelectAll === true) ? _c('div', [_vm._v("\n              This will " + _vm._s(_vm.selectAllAction || 'Delete') + " " + _vm._s(_vm.tableData.filter(function (ref) {
    var selected = ref.selected;

    return selected;
  }).length) + " item(s)\n            ")]) : _vm._e(), _vm._v(" "), (_vm.promptSelectAll === true) ? _c('div', {
    staticClass: "btn btn-success sq",
    staticStyle: {
      "width": "49.5%"
    },
    on: {
      "click": function($event) {
        _vm.$emit('select-all', _vm.tableData.filter(function (ref) {
          var selected = ref.selected;

          return selected;
        }));
        _vm.promptSelectAll = false
      }
    }
  }, [_vm._v("\n              Confirm\n            ")]) : _vm._e(), _vm._v(" "), (_vm.promptSelectAll === true) ? _c('div', {
    staticClass: "btn btn-danger sq",
    staticStyle: {
      "width": "49.5%"
    },
    on: {
      "click": function($event) {
        _vm.promptSelectAll = false
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6",
    staticStyle: {
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._t("head-slot")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: [_vm.showSettings ? 'open' : '', 'table-settings']
  }, [_c('h4', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("Visible columns")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#eee",
      "padding": "10px"
    }
  }, _vm._l((_vm.fields), function(field, i) {
    return _c('div', {
      key: i,
      staticClass: "col-xs-12 col-sm-6 col-md-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": 'is-state' + i
      }
    }, [_vm._v(_vm._s(field.header))]), _vm._v(" "), _c('div', {
      staticClass: "material-switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.hideByDefault),
        expression: "field.hideByDefault"
      }],
      attrs: {
        "true-value": false,
        "false-value": true,
        "id": 'is-state' + i,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(field.hideByDefault) ? _vm._i(field.hideByDefault, null) > -1 : _vm._q(field.hideByDefault, false)
      },
      on: {
        "change": function($event) {
          var $$a = field.hideByDefault,
            $$el = $event.target,
            $$c = $$el.checked ? (false) : (true);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(field, "hideByDefault", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(field, "hideByDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(field, "hideByDefault", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "label-success",
      attrs: {
        "for": 'is-state' + i
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-list"
  }, [_c('thead', {
    staticClass: "pointer",
    attrs: {
      "data-toggle": "tooltip",
      "data-title": "Click to sort by column"
    }
  }, [_c('tr', [(_vm.canModify || _vm.hasSlot) ? _c('th', {
    class: _vm.iconColumnClass
  }) : _vm._e(), _vm._v(" "), (_vm.hasSpecialSlot) ? _c('th', {
    class: _vm.iconColumnClass
  }, [_vm._t("specialSlotHeader")], 2) : _vm._e(), _vm._v(" "), (_vm.allowSelect) ? _c('th', {
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select "), _c('i', {
    staticClass: "fa fa-hand-o-up"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fields), function(field, i) {
    return (!field.hideByDefault) ? _c('th', {
      on: {
        "click": function($event) {
          return _vm.sort(field, i)
        }
      }
    }, [_vm._v("\n              " + _vm._s(field.header) + "\n              "), (i === _vm.sortHeaderActive) ? _c('span', [_c('i', {
      class: [_vm.sortType === 'asc' ? 'fa-chevron-up' : 'fa-chevron-down', 'fa']
    })]) : _vm._e()]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.visibleItems), function(item, i) {
    return _c('tr', [((_vm.canModify && _vm.indexToDelete !== i) || (_vm.hasSlot && _vm.indexToDelete !== i)) ? _c('td', {
      class: _vm.iconColumnClass,
      attrs: {
        "align": "center"
      }
    }, [_vm._t("icons", null, {
      "item": item,
      "index": i
    }), _vm._v(" "), (_vm.showEdit) ? _c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          return _vm.emitEdit(item, i)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.showClone) ? _c('a', {
      staticClass: "btn btn-primary",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Clone"
      },
      on: {
        "click": function($event) {
          return _vm.emitClone(item, i)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-clone"
    })]) : _vm._e(), _vm._v(" "), (_vm.showDelete) ? _c('a', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.promptDelete(item, i)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.hasSpecialSlot) ? _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._t("specialSlot", null, {
      "item": item,
      "index": i
    })], 2) : _vm._e(), _vm._v(" "), (_vm.canModify && _vm.indexToDelete === i) ? _c('td', {
      staticClass: "can-mod",
      attrs: {
        "align": "center"
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.emitDelete(item, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-success",
      on: {
        "click": _vm.cancelDelete
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]) : _vm._e(), _vm._v(" "), (_vm.allowSelect) ? _c('td', [_c('div', {
      staticClass: "form-group height-cap"
    }, [_c('div', {
      staticClass: "material-switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "id": 'allow-select-' + i,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
      },
      on: {
        "change": function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "label-success",
      attrs: {
        "for": 'allow-select-' + i
      }
    })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fields), function(field) {
      return (typeof field.prop !== 'object' && !field.hideByDefault) ? _c('td', {
        class: {
          'text-align-right': field.hasOwnProperty('numericalField')
        }
      }, [(field.showLoadIfNull && (_vm.evaluateProperty(item, field) === null)) ? _c('pulse-loader', {
        attrs: {
          "size": '5px'
        }
      }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.evaluateProperty(item, field)) + " "), (_vm.hasTooltip(item, field)) ? _c('span', {
        attrs: {
          "title": _vm.evaluateTooltip(item, field)
        }
      }, [_vm._v("*")]) : _vm._e()], 1) : _vm._e()
    })], 2)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-xs-6 sml-font"
  }, [(!_vm.usePages) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        position: 'top',
        arrow: true,
        inertia: true,
        size: 'large'
      }),
      expression: "{ position: 'top', arrow: true, inertia: true, size: 'large' }"
    }],
    attrs: {
      "data-html": "#load-tip"
    }
  }, [_vm._v(_vm._s(_vm.minItemVisible) + " to " + _vm._s(_vm.maxItemVisible) + " of " + _vm._s(_vm.getItemsLength))]) : (_vm.usePages) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        position: 'top',
        arrow: true,
        inertia: true,
        size: 'large'
      }),
      expression: "{ position: 'top', arrow: true, inertia: true, size: 'large' }"
    }],
    attrs: {
      "data-html": "#load-tip"
    }
  }, [_vm._v(_vm._s(_vm.pageMessage))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "option-info",
    attrs: {
      "data-html": "#load-tip"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "load-tip"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.loadTip) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col col-xs-6"
  }, [_c('ul', {
    staticClass: "pagination pull-right"
  }, [_c('li', {
    class: [_vm.page === 1 && !_vm.pageNumber ? 'disabled' : '']
  }, [_c('a', {
    on: {
      "click": _vm.reducePage
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    class: [!_vm.canIncrease ? 'disabled' : '']
  }, [_c('a', {
    on: {
      "click": _vm.increasePage
    }
  }, [_vm._v("»")])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8a1557"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/VueTable.vue
// module id = 2110
// module chunks = 1